import { call, put, select } from "redux-saga/effects";
//import { getAllItem as getAllItemPromise } from "@gc-npm/adabyron.catalogue.get-all-item";
import { getAllItem as getAllItemPromise } from "@/adabyron/timer-wrappers/get-all-item";
import { actions as devicesListActions } from "@/reducers/devices-list";
import {
    generateQueryString,
    retornarFiltrosValidos,
} from "@/utils/normalizers/product";
import DOMPurify from "dompurify";
import {
    USUARIO_NO_LOGADO,
    USUARIO_PRIMER_R2R_INCLUIDO,
    USUARIO_R2R_ADICIONAL,
    USUARIO_SEGUNDO_R2R_INCLUIDO,
    USUARIO_R2R_ADICIONAL_CON_RENOVACION,
    PROFILES,
} from "@/constants/get-my-products";
import { getOfferCategoryByClient, getR2RTypeByOfferCategory, normalizeProducts, normalizeProductsToAutocomplete } from "@/utils/normalizers/devices-list";
import { CUSTOM_TAG_FILTERS } from "@/utils/custom-filters"

const contextStore = (state) => state.main.context;
const pageInfoStore = (state) => state.pageInfo;
const devicesListStore = (state) => state.devicesList;
const MyProducts = (state) => state.getMyProducts;

export function* getDeviceListItems(args) {
    try {
        const { data } = args;
        const { build, id, queryParams = {}, catalogueHeaders, showMore } = data;
        const pageInfoStoreData = yield select(pageInfoStore);
        const MyProductsData = yield select(MyProducts);
        const devicesListData = yield select(devicesListStore);
        const { pagination: prevPagination } = devicesListData;
        const { clientType, financing, totalPvp, profiles, includedR2RInfo, categoryFusionInfo, errorCategoryFusionInfo, isUserNewModelR2R, userDiscountNewModelR2R } = MyProductsData;
        const { pacCatalogueSearchParams, stamps } = pageInfoStoreData;

        const context = yield select(contextStore);
        const serverRender = typeof window === "undefined";

        let searchFilters = {
            //pageIndex: "0",
            //pageSize: "39",
            resultFrom: "0",
            resultLimit: "39"
        };
        let offerCategory = "PARTICULARES";
        let offerCategory2 = "";
        let finalFusionCategoryId = categoryFusionInfo;
        let finalClientType = clientType;
        let customTags = !serverRender && sessionStorage.getItem("customTags") || [];
        //let customTags = [];
        let showRenewR2ROffersFilter = false;
        let hasToShowR2RRenovationOffers = false;
        let isRenewR2RBtl = false;

        if (queryParams?.customTags) {
            if (Array.isArray(queryParams.customTags)) {
                customTags = queryParams.customTags;
            } else {
                customTags = [queryParams.customTags];
            }
            if (customTags?.includes("renovacion")) {
                showRenewR2ROffersFilter = true;
                if (queryParams?.btl) {
                    isRenewR2RBtl = true;
                    sessionStorage.setItem("renovacion-btl", true);
                }
            }
            if (customTags?.includes(CUSTOM_TAG_FILTERS.NEW_R2R_MODEL.values[0].id) && isUserNewModelR2R && profiles?.includes(PROFILES.R2R_V2)) {
                searchFilters.profileId = '306'
            }
        }
        if (!serverRender && clientType === USUARIO_NO_LOGADO) {
            isRenewR2RBtl = sessionStorage.getItem("renovacion-btl");
        }

        //Si hay info de cliente (no 0 y no nulo), se usa solo el offerCategory que le corresponda
        //if (finalClientType || isRenewR2RBtl) {
        hasToShowR2RRenovationOffers = showRenewR2ROffersFilter && (includedR2RInfo?.isCancellable || isRenewR2RBtl);
        const generateOfferCategory = getOfferCategoryByClient(finalFusionCategoryId, finalClientType, hasToShowR2RRenovationOffers, isRenewR2RBtl);
        if (generateOfferCategory !== offerCategory) {
            offerCategory2 = generateOfferCategory;
            //Si hay que mostrar oferta de renovación, recalculo tipo de cliente
            /*if (showRenewR2ROffersFilter && includedR2RInfo) {
              ({
                fusionCategoryId: finalFusionCategoryId,
                clientType: finalClientType
              } = getR2RTypeByOfferCategory(offerCategory));
            }*/
        }
        //offerCategory2 = "";
        //}

        let Urlfilters;
        let searcherQuery = "";

        if (Object.keys(queryParams).length !== 0) {
            const sanitizeObject = (inputObject) => {
                return Object.keys(inputObject).reduce((obj, key) => {
                    if (Array.isArray(inputObject[key])) {
                        obj[key] = inputObject[key].map((item) => DOMPurify.sanitize(item));
                    } else {
                        obj[key] = DOMPurify.sanitize(inputObject[key]);
                    }
                    return obj;
                }, {});
            };

            const Basicfilters = sanitizeObject({
                ...queryParams,
                ...pacCatalogueSearchParams,
            });
            let filters = retornarFiltrosValidos(sanitizeObject(Basicfilters));

            //Query del buscador
            if (filters.query !== undefined) {
                searcherQuery = filters.query;
            }

            //Se fuerzan parametros por custo
            searchFilters = {
                ...searchFilters,
                ...filters,
            }
        }

        const environment = process.env.NEXT_PUBLIC_ENV_NAME;

        if (environment !== "prod" && environment !== "dev_ssr") {
            searchFilters.minStock = "0";
        }

        if (
            (finalClientType === USUARIO_PRIMER_R2R_INCLUIDO ||
                finalClientType === USUARIO_SEGUNDO_R2R_INCLUIDO ||
                finalClientType === USUARIO_R2R_ADICIONAL_CON_RENOVACION ||
                finalClientType === USUARIO_R2R_ADICIONAL)
            && Number.isFinite(totalPvp) && id !== "equipamiento") {

            //searchFilters.cl = totalPvp;
        }

        if (devicesListData.productsCards && showMore) {
            // When is showMore, fetch 1 product more due to customizer banner (only showing the first time)
            searchFilters.resultLimit = `${parseInt(searchFilters.resultLimit) + 1}`
            searchFilters.resultFrom = `${parseInt(prevPagination.resultFrom) + parseInt(prevPagination.resultLimit)}`
        }
        Urlfilters = generateQueryString(searchFilters);

        const response = yield call(getAllItemPromise, {
            context,
            build,
            Urlfilters,
            offerCategory,
            offerCategory2,
            ssrHeaders: catalogueHeaders,
        });

        const filters = response.filters.filter((filter) => {
            return (
                filter.id !== "offerCategory" &&
                (pageInfoStoreData && pageInfoStoreData.showDeviceCategoryFilter
                    || filter.id !== "category") && (
                    //Ocultar filtros predefinidos en custo para pac
                    !pageInfoStoreData?.pacCatalogueSearchParams?.[filter.id]
                )
            );
        })

        //Add fake filters renovación si es elegible, o viene forzado el param

        if (CUSTOM_TAG_FILTERS) {
            if (clientType === USUARIO_R2R_ADICIONAL_CON_RENOVACION || isRenewR2RBtl) {
                filters.push(CUSTOM_TAG_FILTERS.RENOVACION);
            }
            if (isUserNewModelR2R && profiles?.includes(PROFILES.R2R_V2)) {
                filters.push(CUSTOM_TAG_FILTERS.NEW_R2R_MODEL);
            }
        }

        //Normalizacion

        const {
            products,
            commercialInfo,
            sort,
            selectedFilters,
            pagination,
            sortingKeys
        } = response;

        let productsCards = normalizeProducts({
            products,
            finalClientType,
            userFinancing: financing,
            finalFusionCategoryId,
            errorCategoryFusionInfo,
            profiles,
            queryParams,
            custoStamps: stamps,
            hasToShowR2RRenovationOffers,
            userDiscountNewModelR2R
        });

        pagination.renderedCount = products.length;

        if (devicesListData.productsCards && showMore) {
            pagination.renderedCount = prevPagination.renderedCount + products.length;
            productsCards = [
                ...devicesListData.productsCards,
                ...productsCards,
            ]
        }

        //Customizer card
        if (commercialInfo && !showMore) {
            const getWindowWidth = () => {
                if (!serverRender) {
                    return window.innerWidth;
                } else {
                    return 1068;
                }
            };
            const pageWidth = getWindowWidth();

            commercialInfo?.banners?.forEach((info) => {
                const custoBannerPosition = pageWidth > 768 ? info.posDesktop - 1 : info.posMobile - 1;
                const bannerItem = {
                    banner: {
                        ...info
                    }
                }
                productsCards.splice(custoBannerPosition, 0, bannerItem)
            });
        }

        //Filtrado de filtros seleccionados

        // Add fake selected filters not provided by PAC
        if (queryParams.customTags) {
            selectedFilters.customTags = customTags;
        }

        const addedKeys = new Set();
        let filtersApplied = 0;

        Object.entries(selectedFilters).forEach(([key, value]) => {
            const processItem = (item) => {
                if (
                    typeof item === "string"
                ) {
                    //Transformamos el selectedFilter a key de filter
                    const newKey = key.toLowerCase().replace("min", "").replace("max", "");
                    //Filtro original
                    const matchingFilter = filters.find(
                        (filterItem) => filterItem.id.toLowerCase() === newKey
                    );
                    if (!addedKeys.has(newKey) && matchingFilter) {
                        //Cada filtro de rango genera un minX y maX, se evita duplicar
                        if (matchingFilter.type === "RANGE") {
                            addedKeys.add(newKey);
                        }
                        filtersApplied += 1;
                    }
                }
            };

            if (key !== "offerCategory") {
                if (Array.isArray(value)) {
                    value.forEach(processItem);
                } else {
                    processItem(value);
                }
            }
        });

        if (searcherQuery !== "") {
            filtersApplied += 1;
        }

        return {
            productsCards,
            serverRender,
            filters,
            sort,
            selectedFilters,
            pagination,
            id,
            sortingKeys,
            searcherQuery,
            filtersApplied,
            showRenewR2ROffersFilter,
            isRenewR2RBtl,
            hasToShowR2RRenovationOffers
        };
    } catch (error) {
        yield put(devicesListActions.failureGetDevicesList());
        console.log("initGetDevicesListItems Error", error);
    }
}

export function* initGetDevicesListItems(args) {
    const data = yield call(getDeviceListItems, args);
    // The request already dispatched failure; do not cancel sibling watchers (including modals).
    if (!data) return;
    yield put(
        devicesListActions.successGetDevicesList({
            productsCards: data.productsCards,
            serverRender: data.serverRender,
            filters: data.filters,
            sort: data.sort,
            selectedFilters: data.selectedFilters,
            pagination: data.pagination,
            id: data.id,
            sortingKeys: data.sortingKeys,
            searcherQuery: data.searcherQuery,
            filtersApplied: data.filtersApplied,
            showRenewR2ROffersFilter: data.showRenewR2ROffersFilter,
            isRenewR2RBtl: data.isRenewR2RBtl,
            hasToShowR2RRenovationOffers: data.hasToShowR2RRenovationOffers
        })
    );
}
